import React from 'react'

import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags'
import { useCreatorIntegrationsV2Query } from '@queries/useCreatorIntegrationsV2Query'

import type { Recommendation } from '../../../Recommendations.types'
import { AppsSlider } from '../components/AppsSlider/AppsSlider'
import { filterSalesApp } from '../utils/filterSalesApp'
import { mapApp } from '../utils/mapApp'
import { sortApp } from '../utils/sortApp'

export const useIntegrationsRecommendation = () => {
  const { creatorIntegrationsV2Query } = useCreatorIntegrationsV2Query()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()

  const apps = (() => {
    if (!creatorIntegrationsV2Query.isSuccess) return

    return creatorIntegrationsV2Query.data.apps
      .filter(filterSalesApp)
      .sort(sortApp)
      .map(mapApp)
      .map((app) => {
        const enabled = app.flag ? dashboardFeatureFlags[app.flag].enabled : true

        return {
          ...app,
          to: enabled ? app.to : undefined,
        }
      })
  })()

  return {
    integrationsRecommendation: {
      id: 'integrations',
      enabled: !!apps && apps.length > 0,
      isLoading: creatorIntegrationsV2Query.isInitialLoading,
      suggestion: <AppsSlider heading="Apps to help your growth" apps={apps || []} />,
    } satisfies Recommendation,
  }
}
